import type { PortalCustomization } from "@redotech/customer-portal-sdk/rpc/schema/portal-customization/get-portal-customization";
import type { CustomerPortalAppSettings } from "../settings";

export function resolveShowSuggestedProducts(
  settings: CustomerPortalAppSettings | undefined,
  customization: PortalCustomization | null | undefined,
): boolean {
  return (
    customization?.pages?.compensationMethod?.behavior?.showSuggestedProducts ??
    !settings?.theme.hideSuggestedProducts
  );
}

export function resolveShowAvailableStoreCredit(
  customization: PortalCustomization | null | undefined,
): boolean {
  return (
    customization?.pages?.compensationMethod?.behavior
      ?.showAvailableStoreCredit ?? true
  );
}
